// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__a8mXP","Cancel":"schedule_Cancel__E9xb1"};